import CompleteStepIcon from '../../assets/icons/CompleteStepIcon.svg?react';
import InactiveStepIcon from '../../assets/icons/InactiveStepIcon.svg?react';
import { EASY_MODE_UPLOAD_STATUS } from '../../constants/easyModeDocuments';
import { getUploadRowView } from '../../utils/easyModeFileUtils';
import {
  uploadRowActionClasses,
  uploadRowClasses,
  uploadRowFolderClasses,
  uploadRowNameClasses,
  uploadRowRemoveClasses,
  uploadRowStatusClasses,
  uploadRowTagClasses,
  uploadRowTagWarningClasses
} from './easyModeClasses';

const documentIconClasses = 'fa-regular fa-file shrink-0 text-subtle';

const spinnerClasses = 'fa fa-spinner animate-spin text-primary';

const failureClasses = 'fa fa-exclamation-circle text-danger';

// Only CLASSIFIED is finished, and only CLASSIFIED is what the header counter counts - so UPLOADED
// spins with the rest. Its bytes are in S3 but no record has come back, which is the same wait as
// CLASSIFYING from the user's side, and showing a tick there made a row the counter had not counted
// look done.
const STATUS_ICONS = {
  [EASY_MODE_UPLOAD_STATUS.PENDING]: <InactiveStepIcon />,
  [EASY_MODE_UPLOAD_STATUS.UPLOADING]: <i className={spinnerClasses} />,
  [EASY_MODE_UPLOAD_STATUS.UPLOADED]: <i className={spinnerClasses} />,
  [EASY_MODE_UPLOAD_STATUS.CLASSIFYING]: <i className={spinnerClasses} />,
  [EASY_MODE_UPLOAD_STATUS.CLASSIFIED]: <CompleteStepIcon />,
  [EASY_MODE_UPLOAD_STATUS.FAILED]: <i className={failureClasses} />,
  [EASY_MODE_UPLOAD_STATUS.BAD_RECORD]: <i className={failureClasses} />
};

const BAD_RECORD_LABEL = 'Could not be read';

const trashIconClasses = 'fa fa-trash-alt';

const EasyModeUploadListRow = ({ row, onRetry, onRemove }) => {
  const { tagLabel, isUnrecognized, hasFailed, isUnreadable, folderName, isRemovable } =
    getUploadRowView({ row });

  return (
    <div className={uploadRowClasses}>
      <i className={documentIconClasses} />
      <span className={uploadRowNameClasses}>{row.fileName}</span>
      {folderName && <span className={uploadRowFolderClasses}>{`in ${folderName}`}</span>}
      {isUnreadable && (
        <span className={uploadRowTagWarningClasses}>{`[${BAD_RECORD_LABEL}]`}</span>
      )}
      {!isUnreadable && tagLabel && (
        <span className={isUnrecognized ? uploadRowTagWarningClasses : uploadRowTagClasses}>
          {`[${tagLabel}]`}
        </span>
      )}
      <span className={uploadRowStatusClasses}>
        {hasFailed && (
          <button
            type="button"
            className={uploadRowActionClasses}
            onClick={() => onRetry({ id: row.id })}
          >
            Retry
          </button>
        )}
        {STATUS_ICONS[row.status]}
        {isRemovable && (
          <button
            type="button"
            className={uploadRowRemoveClasses}
            onClick={() => onRemove({ id: row.id })}
            aria-label="Remove document"
          >
            <i className={trashIconClasses} />
          </button>
        )}
      </span>
    </div>
  );
};

export default EasyModeUploadListRow;
